"use strict";

exports.__esModule = true;
exports.createShouldUpdate = createShouldUpdate;
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Create a shouldComponentUpdate function for the given property names.
 *
 * @example
 * const shouldUpdate = createShouldUpdate("id", "name", "kind");
 * console.log(shouldUpdate(
 *  {id: 123, name: "test", kind: "abc"},
 *  {id: 123, name: "test", kind: "abc", ignoredProp: true}
 * )); // false
 * console.log(shouldUpdate(
 *  {id: 123, name: "test", kind: "foobar"},
 *  {id: 123, name: "test", kind: "abc", ignoredProp: true}
 * )); // true
 */
function createShouldUpdate() {
  for (var _len = arguments.length, propNames = new Array(_len), _key = 0; _key < _len; _key++) {
    propNames[_key] = arguments[_key];
  }
  return function (props, nextProps) {
    for (var i = 0; i < propNames.length; i++) {
      var key = propNames[i];
      if (!(0, _reactFastCompare["default"])(props[key], nextProps[key])) {
        return true;
      }
    }
    return false;
  };
}